import AvField from "availity-reactstrap-validation/lib/AvField"
import AvForm from "availity-reactstrap-validation/lib/AvForm"
import React, { useEffect, useState, useMemo } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Button,
  Input,
  CardTitle,
} from "reactstrap"
import Select from "react-select"
import APIS from "../../apis"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import countryList from "react-select-country-list"
import cresusFond from "../../assets/images/prop1.png"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Flip } from "react-toastify"
//Import Date Picker
import "react-datepicker/dist/react-datepicker.css"
import axios from "axios"
import API from "../../apis"

const Register = props => {
  const [disbutReg, setDisbutReg] = useState(true)
  const [display, setDisplay] = useState(0)
  const options = useMemo(() => countryList().getData(), [])
  const [annee, setAnnee] = useState("")
  const [anneeName, setAnneeName] = useState("")

  const [prenom, setPrenom] = useState("")
  const [nom, setNom] = useState("")
  const [cin, setCin] = useState("")
  const [email, setEmail] = useState("")
  const [telephone, setTelephone] = useState("")
  // const [anneeBac, setAnneeBac] = useState("")
  const [natureLicence, setNatureLicence] = useState([])
  const [selectNatureLicence, setSelectNatureLicence] = useState("")
  const [etablissementOrigine, setEtablissementOrigine] = useState([])
  const [selectEtablissementOrigine, setSelectEtablissementOrigine] =
    useState("")
  const [etablissementName, setEtablissementName] = useState("")
  const [anneeLicence, setAnneeLicence] = useState("")
  const [specilaiteName, setSpecilaiteName] = useState("")
  const [specialite, setSpecialite] = useState([])
  const [selectSpecilaite, setSelectSpecilaite] = useState("")
  const [moyGenAnnee1, setMoyGenAnnee1] = useState("")
  const [sessionLicence1, setSessionLicence1] = useState([])
  const [selectSessionLicence1, setSelectSessionLicence1] = useState("")
  const [credit1, setCredit1] = useState("")
  const [moyGenAnnee2, setMoyGenAnnee2] = useState("")
  const [sessionLicence2, setSessionLicence2] = useState([])
  const [selectSessionLicence2, setSelectSessionLicence2] = useState("")
  const [credit2, setCredit2] = useState("")
  const [moyGenAnnee3, setMoyGenAnnee3] = useState("")
  const [sessionLicence3, setSessionLicence3] = useState([])
  const [selectSessionLicence3, setSelectSessionLicence3] = useState("")
  const [credit3, setCredit3] = useState("")
  const [notePFE, setNotePFE] = useState("")
  const [anneeRedoublement, setAnneeRedoublement] = useState("")
  const [mastere1, setMastere1] = useState([])
  const [selectMastere1, setSelectMastere1] = useState("")
  const [selectMastere2, setSelectMastere2] = useState("")
  const [mastere2, setMastere2] = useState([])
  const [arrayMatiere1, setArrayMatiere1] = useState([])
  const [arrayMatiere2, setArrayMatiere2] = useState([])
  const [choixMatieres1, setChoixMatieres1] = useState({})
  const [choixMatieres2, setChoixMatieres2] = useState({})
  const [notesMatieres1, setNotesMatieres1] = useState({})
  const [notesMatieres2, setNotesMatieres2] = useState({})
  const [releveLicence1, setReleveLicence1] = useState(null)
  const [releveLicence2, setReleveLicence2] = useState(null)
  const [releveLicence3, setReleveLicence3] = useState(null)
  const [diplomeLicence, setDiplomeLicence] = useState(null)
  const [photo, setPhoto] = useState(null)
  const [cinPhoto, setCinPhoto] = useState(null)
  useEffect(async () => {
    const res = await axios
      .get("https://scolarite.backcresus-institut.ovh/api/annee/select")
      .then(res => {
        const resAnnee = axios
          .post(
            "https://scolarite.backcresus-institut.ovh/api/annee/get_by_id",
            { id: res.data.Annee[0].CurrentAnnee[0].value }
          )
          .then(resAnnee => {
            const resMaster = API.post("master/specialite_master/select", {
              annee_id: resAnnee.data.Annee.id,
            }).then(resMaster => {
              setMastere1(resMaster.data.Specialites)
              setMastere2(resMaster.data.Specialites)
            })
            setAnnee(resAnnee.data.Annee.id)
            setAnneeName(resAnnee.data.Annee.annee_scolaire)
          })
      })
    const resNature = await API.get("master/nature_licence/select").then(
      resNature => {
        setNatureLicence(resNature.data.NatureLicences)
      }
    )
    const resEtablissement = await API.get(
      "master/etablissement_origine/select"
    ).then(resEtablissement => {
      setEtablissementOrigine(resEtablissement.data.Etablissement)
    })
    const resSession1 = await API.get("master/candidat/select_session").then(resSession1 => {
      setSessionLicence1(resSession1.data.Session)
      setSessionLicence2(resSession1.data.Session)
      setSessionLicence3(resSession1.data.Session)
    })
  }, [])
  const save = async () => {
    setDisbutReg(false);
    const validations = [
      { field: prenom, message: "⛔ Prénom obligatoire !!" },
      { field: nom, message: "⛔ Nom obligatoire !!" },
      { field: cin, message: "⛔ CIN obligatoire !!" },
      { field: email, message: "⛔ Email obligatoire !!" },
      { field: telephone, message: "⛔ Téléphone obligatoire !!" },
      { field: selectNatureLicence, message: "⛔ Nature de licence obligatoire !!" },
      { field: selectEtablissementOrigine, message: "⛔ Établissement d'origine obligatoire !!" },
      { field: anneeLicence, message: "⛔ Année licence obligatoire !!" },
      {
        field: moyGenAnnee1,
        message: "⛔ Moyenne générale de la première année obligatoire !!",
        min: 0,
        max: 20,
        errorMin: "La Moyenne générale de la première année doit être ≥ 0",
        errorMax: "La Moyenne générale de la première année doit être ≤ 20",
      },
      {
        field: moyGenAnnee2,
        message: "⛔ Moyenne générale de la deuxième année obligatoire !!",
        min: 0,
        max: 20,
        errorMin: "La Moyenne générale de la deuxième année doit être ≥ 0",
        errorMax: "La Moyenne générale de la deuxième année doit être ≤ 20",
      },
      {
        field: moyGenAnnee3,
        message: "⛔ Moyenne générale de la troisième année obligatoire !!",
        min: 0,
        max: 20,
        errorMin: "La Moyenne générale de la troisième année doit être ≥ 0",
        errorMax: "La Moyenne générale de la troisième année doit être ≤ 20",
      },
      { field: selectSessionLicence1, message: "⛔ Session d'admission obligatoire !!" },
      { field: selectSessionLicence2, message: "⛔ Session d'admission obligatoire !!" },
      { field: selectSessionLicence3, message: "⛔ Session d'admission obligatoire !!" },
      {
        field: credit1,
        message: "⛔ Crédit de la première année obligatoire !!",
        min: 0,
        max: 60,
        errorMin: "Le crédit de la première année doit être ≥ 0",
        errorMax: "Le crédit de la première année doit être ≤ 60",
      },
      {
        field: credit2,
        message: "⛔ Crédit de la deuxième année obligatoire !!",
        min: 0,
        max: 60,
        errorMin: "Le crédit de la deuxième année doit être ≥ 0",
        errorMax: "Le crédit de la deuxième année doit être ≤ 60",
      },
      {
        field: credit3,
        message: "⛔ Crédit de la troisième année obligatoire !!",
        min: 0,
        max: 60,
        errorMin: "Le crédit de la troisième année doit être ≥ 0",
        errorMax: "Le crédit de la troisième année doit être ≤ 60",
      },
      {
        field: anneeRedoublement,
        message: "⛔ Nombre d'année de redoublement obligatoire !!",
        min: 0,
        max: 20,
        errorMin: "Le nombre d'année de redoublement doit être ≥ 0",
        errorMax: "Le nombre d'année de redoublement doit être ≤ 20",
      },
      { field: selectMastere1, message: "⛔ Choix de mastère obligatoire !!" },
    ];
    const validateFields = () => {
      for (let v of validations) {
        if (!v.field || v.field === "") {
          setDisbutReg(true);
          toast.error(v.message, { containerId: "A" });
          return false;
        }
        if (v.min !== undefined && v.max !== undefined) {
          if (v.field < v.min) {
            setDisbutReg(true);
            toast.error(v.errorMin || "Valeur trop faible", { containerId: "A" });
            return false;
          }
          if (v.field > v.max) {
            setDisbutReg(true);
            toast.error(v.errorMax || "Valeur trop élevée", { containerId: "A" });
            return false;
          }
        }
      }
      return true;
    };
    const isAutre = selectSpecilaite?.value === "autre";
    const hasName = !!specilaiteName?.trim();
    if (!selectSpecilaite || (isAutre && !hasName)) {
      setDisbutReg(true);
      toast.error(
        isAutre
          ? "⛔ Spécialité de diplômes obtenus et parcours universitaire obligatoire !"
          : "⛔ La spécialité est obligatoire !",
        { containerId: "A" }
      );
      return;
    }

    if (!cinPhoto){
      setDisbutReg(true);
      return toast.error("⛔ Photo de CIN est obligatoire !");
    }
    if (!releveLicence1) {
      setDisbutReg(true);
      return toast.error("⛔ Relevé de licence 1 est obligatoire !")
    }
    if (!releveLicence2){
      setDisbutReg(true);
      return toast.error("⛔ Relevé de licence 2 est obligatoire !")
    }
    if (!releveLicence3){
      setDisbutReg(true);
      return toast.error("⛔ Relevé de licence 3 est obligatoire !")
    }
    if (!diplomeLicence) {
      setDisbutReg(true);
      return toast.error("⛔ Le diplôme de licence est obligatoire !")
    }

    if (selectSpecilaite && selectSpecilaite.value !== "autre") {
      for (let matiere of arrayMatiere1) {
        const note = notesMatieres1[matiere.value];
        if (note === "" || note === null || note === undefined) {
          setDisbutReg(true);
          toast.error(`⛔ La note pour la matière ${matiere.label} est obligatoire !`, { containerId: "A" });
          return;
        }
        if (note < 0 || note > 20) {
          setDisbutReg(true);
          toast.error(`⛔ La note pour la matière ${matiere.label} doit être entre 0 et 20 !`, { containerId: "A" });
          return;
        }
      }
    }

    const isValid = validateFields();
    if (!isValid) return;

    // --- Préparation du FormData ---
    const formData = new FormData();
    formData.append("nom_fr", nom);
    formData.append("prenom_fr", prenom);
    formData.append("email", email);
    formData.append("cin", cin);
    formData.append("telephone", telephone);
    formData.append("etablissement_origine_id", selectEtablissementOrigine.value ?? null);
    formData.append("nature_licence_id", selectNatureLicence.value ?? null);
    formData.append("specialite_id", selectSpecilaite.value ?? null);
    formData.append("specialite_name", specilaiteName);
    formData.append("annee_licence", anneeLicence);
    formData.append("note_pfe", notePFE);
    formData.append("nb_annees_redoublement", anneeRedoublement);
    formData.append("moyenne_gen1", moyGenAnnee1);
    formData.append("moyenne_gen2", moyGenAnnee2);
    formData.append("moyenne_gen3", moyGenAnnee3);
    formData.append("session_licence1_id", selectSessionLicence1.value ?? null);
    formData.append("session_licence2_id", selectSessionLicence2.value ?? null);
    formData.append("session_licence3_id", selectSessionLicence3.value ?? null);
    formData.append("credit1", credit1);
    formData.append("credit2", credit2);
    formData.append("credit3", credit3);
    formData.append("annee_id", annee);

    // const candidature1 = buildCandidature1(selectMastere1, choixMatieres1, notesMatieres1);
    // const candidature2 = buildCandidature2(selectMastere2, choixMatieres2, notesMatieres2);
    // let candidatures = [];
    // if (candidature1) candidatures.push(candidature1);
    // if (candidature2) candidatures.push(candidature2);
    // formData.append("candidatures", JSON.stringify(candidatures));
    const candidature1 = buildCandidature1(selectMastere1,choixMatieres1,notesMatieres1);
    const candidature2 = buildCandidature2(selectMastere2,choixMatieres2,notesMatieres2);
// 🔒 Vérification unicité des masters
    if ( selectMastere1 && selectMastere2 && selectMastere1.value === selectMastere2.value ) {
      setDisbutReg(true);
      toast.error("⛔ Vous ne pouvez pas choisir le même master deux fois", {
        containerId: "A",
      });
      return; // stop l’envoi
    }
    let candidatures = [];
    if (candidature1) candidatures.push(candidature1);
    if (candidature2) candidatures.push(candidature2);

    formData.append("candidatures", JSON.stringify(candidatures));

    formData.append("interne", selectEtablissementOrigine.value === 3 ? 1 : 0);
    formData.append("cin_numerique", cinPhoto);
    formData.append("releve_licence_1", releveLicence1);
    formData.append("releve_licence_2", releveLicence2);
    formData.append("releve_licence_3", releveLicence3);
    formData.append("diplome_licence", diplomeLicence);
    formData.append("photo", photo);

    // --- Envoi API ---
    try {
      const res = await APIS.post("/master/candidat/add", formData, {
        headers: { "Content-Type": "multipart/form-data", annee: annee },
      });

      if (res.data.errNum == 200) {
        setDisbutReg(false);
        toast.success("✔️" + res.data.msg, { containerId: "A" });
        props.history.push("/Score?id=" + res.data.Candidat + "/" + cin);
      } else {
        setDisbutReg(true);
        toast.error("⛔ " + res.data.msg, { containerId: "A" });
      }
    }
    catch (error) {
      setDisbutReg(true);
      toast.error("⛔ Une erreur est survenue lors de l'envoi", { containerId: "A" });
    }
  };
  const optionsAvecAutre = [
    ...specialite,
    { label: "Autres", value: "autre" },
  ]
  const getSpec = async event => {
    setSelectSpecilaite("")
    setSpecilaiteName("")
    setSelectEtablissementOrigine(event)
    const res = await API.get("master/select_specialite").then(res => {
      setSpecialite(res.data.SpecialiteLicence)
    })
  }
  const getMatiereMastere1 = async (event) => {
    setSelectMastere1(event);
    const res = await API.post("master/get_master_matieres_by_specialite", {
      annee_id: annee,
      specialite_master_id: event.value,
    });
    const matieres = res.data.matieres || [];
    setArrayMatiere1(matieres);
    const initialChoices1 = {};
    const initialNotes1 = {};
    matieres.forEach((m) => {
      initialChoices1[m.value] = null;
      initialNotes1[m.value] = "";
    });
    setChoixMatieres1(initialChoices1);
    setNotesMatieres1(initialNotes1);
  };
  const getMatiereMastere2 = async (event) => {
    setSelectMastere2(event);

    const res = await API.post("master/get_master_matieres_by_specialite", {
      annee_id: annee,
      specialite_master_id: event.value,
    });

    const matieres = res.data.matieres || [];
    setArrayMatiere2(matieres);

    // Réinitialiser les choix et notes pour le Mastere2
    const initialChoices2 = {};
    const initialNotes2 = {};
    matieres.forEach((m) => {
      initialChoices2[m.value] = null;
      initialNotes2[m.value] = "";
    });

    setChoixMatieres2(initialChoices2); // <-- Correct
    setNotesMatieres2(initialNotes2);   // <-- Correct
  };

  const handleNoteChange1 = (matiereId, value) => {
    setNotesMatieres1(prev => ({
      ...prev,
      [matiereId]: value,
    }))
  }
  const handleNoteChange2 = (matiereId, value) => {
    setNotesMatieres2(prev => ({
      ...prev,
      [matiereId]: value,
    }))
  }

  const buildCandidature1 = (specialite, choixMatieres, notesMatieres) => {
    if (!specialite) return null; // master non sélectionné

    const matieres = Object.keys(notesMatieres) // <-- utiliser les notes pour toutes les matières
      .map(matiereId => ({
        id: Number(matiereId),
        note: Number(notesMatieres[matiereId] || 0),
      }));

    return {
      specialite_master_id: specialite.value,
      priorite: specialite === selectMastere1 ? 1 : 1,
      matieres,
    };
  };
  const buildCandidature2 = (specialite, choixMatieres, notesMatieres) => {
    if (!specialite) return null; // master non sélectionné

    const matieres = Object.keys(notesMatieres) // <-- utiliser les notes pour toutes les matières
      .map(matiereId => ({
        id: Number(matiereId),
        note: Number(notesMatieres[matiereId] || 0),
      }));

    return {
      specialite_master_id: specialite.value,
      priorite: specialite === selectMastere2 ? 0 : 0,
      matieres,
    };
  };

  const addPhoto = e => {
    var file = e.target.files[0]
    setPhoto(file)
  }
  const addCIN = e => {
    var file = e.target.files[0]
    setCinPhoto(file)
  }
  const addReleveDiplome = e => {
    var file = e.target.files[0]
    setDiplomeLicence(file)
  }
  const addReleveLicence1 = e => {
    var file = e.target.files[0]
    setReleveLicence1(file)
  }
  const addReleveLicence2 = e => {
    var file = e.target.files[0]
    setReleveLicence2(file)
  }
  const addReleveLicence3 = e => {
    var file = e.target.files[0]
    setReleveLicence3(file)
  }


  return (
    <div
      style={{
        backgroundImage: `url(${cresusFond})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "auto",
        width: "auto",
      }}
    >
      {display === 0 ? (
        <div style={{ paddingTop: "4%" }}>
          <Container>
            <Row className="justify-content-center">
              <Col md={12} lg={12} xl={12}>
                <Card style={{ backgroundColor: "#dad8d8" }} className="">
                  <div>
                    {" "}
                    <div>
                      <Row>
                        <Col className="justify-content-center pt-4">
                          <h1
                            style={{
                              color: "#3ba897",
                              textAlign: "center",
                            }}
                          >
                            <p>FICHE DES RENSEIGNEMENTS MASTERE</p>
                            <p>A.U {anneeName}</p>
                          </h1>
                        </Col>
                      </Row>
                    </div>
                    <CardBody className="pt-4">
                      <CardTitle
                        style={{ color: "#556ee6" }}
                        className="h4 mb-4 mt-4"
                      >
                        Informations personnelles :
                      </CardTitle>
                      <AvForm className="form-horizontal">
                        <Row>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Prénom :
                              </Label>
                              <AvField
                                name="prenom"
                                placeholder="Entrer Prénom"
                                type="text"
                                errorMessage="* Prénom obligatoire"
                                className="form-control "
                                validate={{ required: { value: true } }}
                                onChange={e => setPrenom(e.target.value)}
                              />
                            </div>
                          </Col>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Nom de la famille :
                              </Label>
                              <AvField
                                name="nom"
                                placeholder="Entrer Nom"
                                type="text"
                                errorMessage="* Nom obligatoire"
                                className="form-control "
                                validate={{ required: { value: true } }}
                                onChange={e => setNom(e.target.value)}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                CIN :
                              </Label>
                              <AvField
                                name="CIN"
                                placeholder="Entrer CIN"
                                type="text"
                                className="form-control "
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "* CIN obligatoire",
                                  },
                                  pattern: {
                                    // ✅ regex correcte
                                    value: /^[0-9]{8}$/,
                                    errorMessage:
                                      "Le CIN doit contenir exactement 8 chiffres",
                                  },
                                }}
                                onChange={e => setCin(e.target.value)}
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Email :
                              </Label>
                              <AvField
                                name="Email"
                                placeholder="Entrer Email"
                                type="email"
                                errorMessage="* Email obligatoire"
                                className="form-control "
                                validate={{ required: { value: true } }}
                                onChange={e => setEmail(e.target.value)}
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Numéro de téléphone :
                              </Label>
                              <AvField
                                name="telephone"
                                placeholder="Entrer Numéro de téléphone"
                                type="text" // ⚠️ changer "tel" en "text"
                                className="form-control"
                                value={telephone}
                                onChange={e => setTelephone(e.target.value)}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage:
                                      "* Numéro de téléphone obligatoire",
                                  },
                                  pattern: {
                                    // ✅ regex correcte
                                    value: /^[0-9]{8}$/,
                                    errorMessage:
                                      "Le numéro doit contenir exactement 8 chiffres",
                                  },
                                }}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="12">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Photo :
                              </Label>
                              <Input
                                onChange={e => addPhoto(e)}
                                className="form-control"
                                type="file"
                                id="formFile"
                                accept="image/png, image/jpeg, image/jpg"
                              />
                            </div>
                          </Col>
                        </Row>
                        <CardTitle
                          style={{ color: "#556ee6" }}
                          className="h4 mb-4 mt-4"
                        >
                          Diplôme obtenu et parcours universitaire :
                        </CardTitle>
                        <Row>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Nature de la licence :
                              </Label>
                              <Select
                                options={natureLicence}
                                isSearchable={true}
                                value={selectNatureLicence}
                                onChange={e => setSelectNatureLicence(e)}
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                {"Etablissement d'origine"} :
                              </Label>
                              <Select
                                options={etablissementOrigine}
                                isSearchable={true}
                                value={selectEtablissementOrigine}
                                onChange={e => getSpec(e)}
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                {"Année d'obtention du diplôme de licence :"}
                              </Label>
                              <AvField
                                name="anneeObtentionLicence"
                                placeholder="Entrer Année d'obtention du diplôme de licence "
                                type="text"
                                errorMessage="* Année d'obtention du diplôme de licence obligatoire"
                                className="form-control "
                                validate={{ required: { value: true } }}
                                onChange={e => setAnneeLicence(e.target.value)}
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                {"Spécilaité :"}
                              </Label>
                                <Select
                                  options={optionsAvecAutre}
                                  isSearchable={true}
                                  value={selectSpecilaite}
                                  onChange={e => setSelectSpecilaite(e)}
                                />
                            </div>
                          </Col>
                          {selectSpecilaite?.value === "autre" && (
                            <Col lg="4">
                              <div className="mb-3">
                                <Label for="basicpill-firstname-input1">
                                  Nom spécialité :
                                </Label>

                                <AvField
                                  name="specialite"
                                  placeholder="Entrer spécialité"
                                  type="text"
                                  errorMessage="* Spécialité obligatoire"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  onChange={e => setSpecilaiteName(e.target.value)}
                                />
                              </div>
                            </Col>
                          )}
                        </Row>
                        <CardTitle
                          style={{ color: "#556ee6" }}
                          className="h4 mb-4 mt-4"
                        >
                          Eléments du calcul de score :
                        </CardTitle>
                        <Row>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Moyenne générale de la première année :
                              </Label>
                              <AvField
                                name="Moyenne générale de la première année"
                                placeholder="Entrer Moyenne générale de la première année"
                                type="number"
                                errorMessage="* Moyenne générale de la première année obligatoire"
                                className="form-control"
                                onChange={e => setMoyGenAnnee1(e.target.value)}
                                validate={{
                                  required: { value: true },
                                  min: {
                                    value: 0,
                                    errorMessage: "La moyenne doit être ≥ 0",
                                  },
                                  max: {
                                    value: 20,
                                    errorMessage: "La moyenne doit être ≤ 20",
                                  },
                                }}
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Crédit de la première année :
                              </Label>
                              <AvField
                                name="Crédit de la première année"
                                placeholder="Entrer Crédit de la première année"
                                type="number"
                                errorMessage="* Crédit de la première année obligatoire"
                                className="form-control "
                                validate={{
                                  required: { value: true },
                                  min: {
                                    value: 0,
                                    errorMessage: "La moyenne doit être ≥ 0",
                                  },
                                  max: {
                                    value: 60,
                                    errorMessage: "La moyenne doit être ≤ 60",
                                  },
                                }}
                                onChange={e => setCredit1(e.target.value)}
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                {"Session d'admission :"}
                              </Label>
                              <Select
                                options={sessionLicence1}
                                isSearchable={true}
                                value={selectSessionLicence1}
                                onChange={e => setSelectSessionLicence1(e)}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Moyenne générale de la deuxième année :
                              </Label>
                              <AvField
                                name="Moyenne générale de la deuxième année"
                                placeholder="Entrer Moyenne générale de la deuxième année"
                                type="number"
                                errorMessage="* Moyenne générale de la deuxième année obligatoire"
                                className="form-control "
                                validate={{
                                  required: { value: true },
                                  min: {
                                    value: 0,
                                    errorMessage: "La moyenne doit être ≥ 0",
                                  },
                                  max: {
                                    value: 20,
                                    errorMessage: "La moyenne doit être ≤ 20",
                                  },
                                }}
                                onChange={e => setMoyGenAnnee2(e.target.value)}
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Crédit de la deuxième année :
                              </Label>
                              <AvField
                                name="Crédit de la deuxième année"
                                placeholder="Entrer Crédit de la deuxième année"
                                type="number"
                                errorMessage="* Crédit de la deuxième année obligatoire"
                                className="form-control "
                                validate={{
                                  required: { value: true },
                                  min: {
                                    value: 0,
                                    errorMessage: "La moyenne doit être ≥ 0",
                                  },
                                  max: {
                                    value: 60,
                                    errorMessage: "La moyenne doit être ≤ 60",
                                  },
                                }}
                                onChange={e => setCredit2(e.target.value)}
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                {"Session d'admission :"}
                              </Label>
                              <Select
                                options={sessionLicence2}
                                isSearchable={true}
                                value={selectSessionLicence2}
                                onChange={e => setSelectSessionLicence2(e)}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Moyenne générale de la troisième année :
                              </Label>
                              <AvField
                                name="Moyenne générale de la troisième année"
                                placeholder="Entrer Moyenne générale de la troisième année"
                                type="number"
                                errorMessage="* Moyenne générale de la troisième année obligatoire"
                                className="form-control "
                                validate={{
                                  required: { value: true },
                                  min: {
                                    value: 0,
                                    errorMessage: "La moyenne doit être ≥ 0",
                                  },
                                  max: {
                                    value: 20,
                                    errorMessage: "La moyenne doit être ≤ 20",
                                  },
                                }}
                                onChange={e => setMoyGenAnnee3(e.target.value)}
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Crédit de la troisième année :
                              </Label>
                              <AvField
                                name="Crédit de la troisième année"
                                placeholder="Entrer Crédit de la troisième année"
                                type="number"
                                errorMessage="* Crédit de la troisième année obligatoire"
                                className="form-control "
                                validate={{
                                  required: { value: true },
                                  min: {
                                    value: 0,
                                    errorMessage: "La moyenne doit être ≥ 0",
                                  },
                                  max: {
                                    value: 60,
                                    errorMessage: "La moyenne doit être ≤ 60",
                                  },
                                }}
                                onChange={e => setCredit3(e.target.value)}
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                {"Session d'admission :"}
                              </Label>
                              <Select
                                options={sessionLicence3}
                                isSearchable={true}
                                value={selectSessionLicence3}
                                onChange={e => setSelectSessionLicence3(e)}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                {"Nombre d'année de redoublement :"}
                              </Label>
                              <AvField
                                name="Nombre d'année de redoublement"
                                placeholder="Entrer Nombre d'année de redoublement"
                                type="number"
                                errorMessage="* Nombre d'année de redoublement obligatoire"
                                className="form-control "
                                validate={{
                                  required: { value: true },
                                  min: {
                                    value: 0,
                                    errorMessage: "La moyenne doit être ≥ 0",
                                  },
                                  max: {
                                    value: 20,
                                    errorMessage: "La moyenne doit être ≤ 20",
                                  },
                                }}
                                onChange={e =>
                                  setAnneeRedoublement(e.target.value)
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                        <CardTitle
                          style={{ color: "#556ee6" }}
                          className="h4 mb-4 mt-4"
                        >
                          Dossier à télécharger :
                        </CardTitle>
                        <Row>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                CIN (recto/verso dans un même fichier PDF)  :
                              </Label>
                              <Input
                                onChange={e => addCIN(e)}
                                className="form-control"
                                type="file"
                                id="formFile"
                                accept="application/pdf"
                                required
                              />
                            </div>
                          </Col>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Relevée de diplôme (copie conforme) :
                              </Label>
                              <Input
                                onChange={e => addReleveDiplome(e)}
                                className="form-control"
                                type="file"
                                id="formFile"
                                accept="application/pdf"
                                required
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Relevée de licence première année :
                              </Label>
                              <Input
                                onChange={e => addReleveLicence1(e)}
                                className="form-control"
                                type="file"
                                id="formFile"
                                accept="application/pdf"
                                required
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Relevée de licence deuxième année :
                              </Label>
                              <Input
                                onChange={e => addReleveLicence2(e)}
                                className="form-control"
                                type="file"
                                id="formFile"
                                accept="application/pdf"
                                required
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                Relevée de licence troiséme année :
                              </Label>
                              <Input
                                onChange={e => addReleveLicence3(e)}
                                className="form-control"
                                type="file"
                                id="formFile"
                                accept="application/pdf"
                                required
                              />
                            </div>
                          </Col>

                        </Row>
                        <CardTitle
                          style={{ color: "#556ee6" }}
                          className="h4 mb-4 mt-4"
                        >
                          Choix de masrères :
                        </CardTitle>

                        <Row>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                {"Mastère :"}
                              </Label>
                              <Select
                                options={mastere1}
                                isSearchable={true}
                                value={selectMastere1}
                                onChange={e => getMatiereMastere1(e)}
                              />
                            </div>
                          </Col>
                        </Row>
                        <h4> Matières fondamentales :</h4>
                        <Row>
                          <Col lg="6">
                            {arrayMatiere1.map((matiere, index) => (
                              <div
                                key={matiere.value}
                                className="mb-3 border p-2 rounded"
                              >
                                <h6>
                                  {index + 1}. Moyenne de {matiere.label}
                                </h6>
                                <AvField
                                  name={`note_${matiere.value}`}
                                  placeholder="Entrer Note / 20"
                                  type="number"
                                  className="form-control"
                                  value={notesMatieres1[matiere.value] || ""}
                                  validate={{
                                    min: {
                                      value: 0,
                                      errorMessage: "La note doit être ≥ 0",
                                    },
                                    max: {
                                      value: 20,
                                      errorMessage: "La note doit être ≤ 20",
                                    },
                                  }}
                                  onChange={e =>
                                    handleNoteChange1(matiere.value, e.target.value)
                                  }
                                />
                              </div>
                            ))}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label for="basicpill-firstname-input1">
                                {"Mastère 2 (facultatif) :"}
                              </Label>
                              <Select
                                options={mastere2}
                                isSearchable={true}
                                value={selectMastere2}
                                onChange={e => getMatiereMastere2(e)}
                              />
                            </div>
                          </Col>
                        </Row>
                        <h4> Matières fondamentales :</h4>
                        <Row>
                          <Row>
                            <Col lg="6">
                              {arrayMatiere2.map((matiere, index) => (
                                <div
                                  key={matiere.value}
                                  className="mb-3 border p-2 rounded"
                                >
                                  <h6>
                                    {index + 1}. Moyenne de {matiere.label}
                                  </h6>
                                  <AvField
                                    name={`note_${matiere.value}`}
                                    placeholder="Entrer Note / 20"
                                    type="number"
                                    className="form-control"
                                    value={notesMatieres2[matiere.value] || ""}
                                    validate={{
                                      min: {
                                        value: 0,
                                        errorMessage: "La note doit être ≥ 0",
                                      },
                                      max: {
                                        value: 20,
                                        errorMessage: "La note doit être ≤ 20",
                                      },
                                    }}
                                    onChange={e =>
                                      handleNoteChange2(matiere.value, e.target.value)
                                    }
                                  />
                                </div>
                              ))}
                            </Col>
                          </Row>
                        </Row>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {" "}
                          <Col
                            lg="12"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Button
                              type="button"
                              className="btn btn-warning mb-2 me-2"
                              onClick={() => props.history.push("/Redirection")}
                            >
                              Annuler
                            </Button>
                            <Button
                              id="Confirmer"
                              name="Confirmer"
                              type="button"
                              color="primary"
                              className="btn btn-primary mb-2 me-2"
                              disabled={!disbutReg}
                              onClick={save}
                            >
                              Confirmer
                            </Button>
                          </Col>
                        </div>
                      </AvForm>
                    </CardBody>
                    <div className="mt-1 text-center">
                      <p>
                        © {new Date().getFullYear()} Cresus. Crafted with{" "}
                        <i className="mdi mdi-heart text-danger" /> by{" "}
                        <a href="https://cresus.pro/">cresus.pro</a>
                      </p>
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      ) : (
        <div style={{ padding: "19.2% 0%" }}>
          <Container>
            <div className="alert alert-success" role="alert">
              <h4 className="alert-heading">Succès !!</h4>
              <p className="mb-0">Cher enseignant,</p>
              <p className="mb-0">
                Nous avons bien reçu votre demande {"d'inscription"} et nous
                vous remercions de {"l’intérêt"} et du temps que vous nous
                témoignez. Votre compte sera activé par {"l'admin"} dans les
                plus brefs délais aprés la vérification de vos cordonnées . Si
                vous avez la moindre question,{"l'équipe"} administrative
                demeure à votre disposition.
              </p>
              <p className="mb-0">Bonne journée.</p>
            </div>
          </Container>
        </div>
      )}
      <ToastContainer
        transition={Flip}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </div>
  )
}

export default withRouter(Register)

Register.propTypes = {
  history: PropTypes.object,
}
